import { Button, List, MenuItem, Popover, styled } from '@mui/material';
import {
  bindPopover,
  bindTrigger,
  usePopupState,
} from 'material-ui-popup-state/hooks';
import { SearchSource } from 'src/@types/ai';
import Iconify from 'src/components/iconify';
import { AISearchItem } from './AISearchItem';

export const AISearchSources = ({
  searchSources,
}: { searchSources: SearchSource[] }) => {
  const popupState = usePopupState({
    variant: 'popover',
    popupId: 'sourcesPopover',
  });

  return (
    <>
      <StyledSourcesButton
        {...bindTrigger(popupState)}
        startIcon={<Iconify icon="tabler:world" />}
        variant="contained"
        color="inherit"
        size="small"
      >
        Sources
      </StyledSourcesButton>

      <StyledPopover
        {...bindPopover(popupState)}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <List>
          {searchSources?.map((source, index) => (
            <MenuItem key={index}>
              <AISearchItem key={index} source={source} />
            </MenuItem>
          ))}
        </List>
      </StyledPopover>
    </>
  );
};

const StyledSourcesButton = styled(Button)(({ theme }) => ({
  ...theme.typography.caption,
  height: 'unset',
  color: theme.palette.text.secondary,
  '&:hover': {
    color: theme.palette.text.primary,
  },
  '& .MuiButton-startIcon': {
    marginRight: theme.spacing(0.5),
  },
}));

const StyledPopover = styled(Popover)(({ theme }) => ({
  maxWidth: '100vw',
  [theme.breakpoints.up('sm')]: {
    maxWidth: 500,
  },
}));
